module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C880"
  }, [_c('span', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("PART ")]), _vm._v("TWO ")]), _vm._v(" "), _c('p', {
    staticClass: "C875"
  }, [_c('strong', [_vm._v("ONGOING PROCESSES IN THE HUMAN POPULATION ")])]), _vm._v(" "), _c('p', {
    staticClass: "P45"
  }, [_vm._v("The origination and maintenance of any system requires energy, biological or societal. In order to feed, our most basic activity to which all others boil down, we need a sufficient agricultural system. This system itself depends on a large supply of energy for pumping up water, for the production of fertilizers and other chemicals, as a trading and a transport system, as a financial system for making payments, for keeping the value of money under control, and so on. All these systems individually require energy and material, as do the necessary interactions between individual people. Moreover, they show a dynamic of their own—a dynamic beyond the control of humans. ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff0f1142","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/07_PART_2_O.vue
// module id = 75
// module chunks = 0